import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M4.176 8.264a.769.769 0 110-1.537.769.769 0 010 1.537zM2.102 10.264a.769.769 0 110-1.537.769.769 0 010 1.537zM5.147 11.032a.769.769 0 110-1.538.769.769 0 010 1.538zM9.97 7.576a2.959 2.959 0 011.845-.135c.83-1.483 1.267-4.374 1.378-5.493a.792.792 0 111.574.154c-.043.449-.406 3.955-1.562 6.058.317.266.565.607.72.99.228.634.248 1.324.055 1.97L8.444 8.885c.34-.601.88-1.065 1.525-1.31zM4.298 12.564c.092 0 2.16.467 3.783-2.83l5.665 2.295c-.246.996-.88 2.995-2.208 3.764a.314.314 0 01-.148.043h-.184a8.039 8.039 0 01-2.135-.313 5.887 5.887 0 001.723-1.846.464.464 0 00-.806-.461 5.474 5.474 0 01-2.018 1.937c-.363-.135-.72-.283-1.052-.43a6.009 6.009 0 001.956-1.79.485.485 0 10-.824-.51 5.5 5.5 0 01-2.202 1.808c-.635-.332-1.252-.7-1.845-1.101a.314.314 0 01-.105-.388.326.326 0 01.4-.178z",
      fill: "#2d6ded"
    }
  )
);
export {
  t as default
};
